import React, { useCallback } from "react"
import Spinning from 'app/components/Spinning'

export default ({ className, children, onClick, isSpinning = false }) => {
  const onClickWrapper = useCallback(() => {
    if(isSpinning) return

    onClick();
  })

  return <button className={ className } onClick={ onClickWrapper }>
           { isSpinning ? <Spinning className="text-xl" /> : children }
         </button>
}
